import i18n from "i18next";
import type { FC } from "react";

import { PagesStyled } from "src/app/pages/pagesStyled";
import type { PageProps } from "./PageLayout";

export const NoAccessLayout: FC<PageProps> = () => {
    return (
        <PagesStyled>
            <p className="aevi-section-subtitle">{i18n.t("common.unauthorized")}</p>
            <div className="aevi-text">{i18n.t("access-denied.message")}</div>
        </PagesStyled>
    );
};
